import { render, staticRenderFns } from "./ForwardToOption.vue?vue&type=template&id=d0b5fe4e&"
import script from "./ForwardToOption.vue?vue&type=script&lang=js&"
export * from "./ForwardToOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0b5fe4e')) {
      api.createRecord('d0b5fe4e', component.options)
    } else {
      api.reload('d0b5fe4e', component.options)
    }
    module.hot.accept("./ForwardToOption.vue?vue&type=template&id=d0b5fe4e&", function () {
      api.rerender('d0b5fe4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/emailChannels/ForwardToOption.vue"
export default component.exports